import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { TokenInterceptor } from './shared/interceptors/token.interceptor';
import { AppComponent } from './app.component';
// Locale - Idioma de Angular (datePipe, etc.)
// https://github.com/angular/angular/tree/master/packages/common/locales
// Primero hay que importar esto antes de colocarlo en los providers
import es from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';
registerLocaleData(es);
// Modulo Http
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
// OpenStreetMaps
import { LeafletModule } from '@asymmetrik/ngx-leaflet';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    LeafletModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    // Para proveer el LOCALE_ID hay que usar un valor el cual toca importar
    { provide: LOCALE_ID, useValue: 'es-CO' },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
